import _ from 'lodash'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useSelector, connect } from 'react-redux'

import Box from '~/core/Box'
import Button from '~/core/Button'
import Image from '~/core/Image'
import Text from '~/core/Text'
import { ADMIN_PATH, QUOTES_PATH } from '~/redux-modules/preferences'
import { openModal } from '~/redux-modules/modals'
import { selectFlags } from '~/apps/consumer/components/TopNav/logic'
import icons from '~/apps/consumer/icons'
import colors from '~/styles/_colors.css'

import ReturnButton from './ReturnButton'
import {
    PLACEMENT,
    REFRESH_MESSAGE_ORDER,
    REFRESH_MESSAGE_QUOTE,
    LEARN_MORE,
    UNABLE_DISPLAY_MESSAGE_QUOTE,
    UNABLE_DISPLAY_MESSAGE_ORDER,
} from './constants'
import styles from './styles.css'

const QUOTE_NOT_FOUND_TIMEOUT = 10000

interface ItemNotFoundPropsType {
    isQuote: boolean
    openModal: Function
}
function mapStateToProps() {
    return {
        openModal,
    }
}

const ItemNotFound = (props: ItemNotFoundPropsType) => {
    const { isQuote } = props

    const navigate = useNavigate()
    const { userId: quoteOwnerId } = useParams<{ userId: string }>()

    const { isGetEarlyAccessTeamsFlagEnabled } = useSelector(selectFlags)

    const route = quoteOwnerId
        ? `${ADMIN_PATH}/user/${quoteOwnerId}/quotes`
        : QUOTES_PATH

    const TeamsVisibilityMessage = () => (
        <Box display="inline">
            <Text>
                Looking for visibility into your team’s{' '}
                {isQuote ? 'orders' : 'order'}? Try{' '}
            </Text>
            <Text color={'blackAlpha65'}>Fictiv Premium</Text>
            <Text>, a new collaborative manufacturing experience.</Text>
        </Box>
    )

    useEffect(() => {
        if (!isGetEarlyAccessTeamsFlagEnabled) {
            const timer = setTimeout(() => {
                navigate(route)
            }, QUOTE_NOT_FOUND_TIMEOUT)

            return () => {
                clearTimeout(timer)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Box className={styles.sectionQuote}>
            <Image src={icons.errorIcon} className={styles.errorIcon} />
            <Box className={styles.header}>
                {isQuote
                    ? UNABLE_DISPLAY_MESSAGE_QUOTE
                    : UNABLE_DISPLAY_MESSAGE_ORDER}
            </Box>
            <Box className={styles.subheader1} color={colors.blackAlpha65}>
                {isQuote ? REFRESH_MESSAGE_QUOTE : REFRESH_MESSAGE_ORDER}
            </Box>
            {isGetEarlyAccessTeamsFlagEnabled && (
                <>
                    <Box
                        className={styles.subheader2}
                        color={colors.blackAlpha45}
                    >
                        <TeamsVisibilityMessage />
                    </Box>
                    <Box className={styles.buttonEarlyAccess}>
                        <Button
                            type="primary"
                            name="get-early-access"
                            placement={PLACEMENT}
                            onClick={() => {
                                props.openModal('UPSELL')
                            }}
                        >
                            {LEARN_MORE}
                        </Button>
                    </Box>
                </>
            )}
            <ReturnButton isQuote={isQuote} />
        </Box>
    )
}

export default _.flowRight(connect(mapStateToProps, { openModal }))(
    ItemNotFound,
)
